// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { Fragment } from 'react';
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import moment from 'moment';
import Image from '../utils/Image';
import FieldView from '../utils/FieldView';
import { getEventImage } from '../forms/events/EventManager';
import '../../styles/components/FilterPanel.css';
import { getCreatedFrom } from '../../infrastructure/utils/events';
import CollapsableItem from '../utils/CollapsableItem';
import { isMobileResolution } from '../../infrastructure/utils/common';
import { getConfig } from '../../config';

class GroundTransportEventView extends React.PureComponent {
  render() {
    const {
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      event,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      party,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      name,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      dates,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      attendees,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      title,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      allMembers,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      activity,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      images,
    } = this.props;
    const centerFrom = {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      lat: event.eventLocationFrom
        ? // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/prop-types
          event.eventLocationFrom.latitude
        : // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/prop-types
          event.passengers.locationFrom.latitude,
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      lng: event.eventLocationFrom
        ? // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/prop-types
          event.eventLocationFrom.longitude
        : // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/prop-types
          event.passengers.locationFrom.longitude,
    };
    const centerTo = {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      lat: event.eventLocationTo
        ? // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/prop-types
          event.eventLocationTo.latitude
        : // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/prop-types
          event.passengers.locationTo.latitude,
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      lng: event.eventLocationTo
        ? // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/prop-types
          event.eventLocationTo.longitude
        : // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/prop-types
          event.passengers.locationTo.longitude,
    };
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    let addressFrom = event.eventLocationFrom
      ? // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        event.eventLocationFrom.address
      : // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        event.passengers.locationFrom.address;
    if (!addressFrom) {
      addressFrom = '';
    }
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    const addressTo = event.eventLocationTo
      ? // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        event.eventLocationTo.address
      : // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        event.passengers.locationTo.address;
    if (!addressFrom) {
      addressFrom = '';
    }
    const image = getEventImage(event, images);
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { google } = this.props;
    const notAvailableLabel = 'n/a';
    const config = getConfig();
    return (
      <Fragment>
        <div className='media'>
          <div className='media-left'>
            <Image src={image} width='200px' height='200px' alt='event' />
          </div>
          <div className='media-body'>
            <h1 style={{ fontSize: '30px', fontWeight: 'bold' }}>{title}</h1>
            <h2 style={{ fontSize: '30px', fontWeight: 'bold' }}>{name}</h2>
            <div className='event-dates'>
              <i className='fas fa-clock' />
              {dates}
            </div>
            <div className={!isMobileResolution() ? 'data-box' : ''}>
              <FieldView name='Party:' md={2} vmd={4}>
                {/* TODO: Fix this the next time the file is edited. */}
                {/* eslint-disable-next-line react/prop-types */}
                {event.partyId ? (
                  // TODO: Fix this the next time the file is edited.
                  // eslint-disable-next-line react/prop-types
                  <a href={`/party/${party.partyId}`}>{party.partyName}</a>
                ) : (
                  notAvailableLabel
                )}
              </FieldView>
              <FieldView name='Type:' md={2} vmd={6}>
                {/* TODO: Fix this the next time the file is edited. */}
                {/* eslint-disable-next-line react/prop-types */}
                {event.eventCategory}
              </FieldView>
              <FieldView name='Created From:' md={2} vmd={4}>
                {getCreatedFrom(event, activity, party)}
              </FieldView>
              <FieldView name='Activity:' md={2} vmd={4}>
                {/* TODO: Fix this the next time the file is edited. */}
                {/* eslint-disable-next-line react/prop-types */}
                {event.activityId ? (
                  <a
                    // TODO: Fix this the next time the file is edited.
                    // eslint-disable-next-line react/prop-types
                    href={`${config.batchAdminURL}/experiences/${event.activityId}`}
                  >
                    View activity
                  </a>
                ) : (
                  notAvailableLabel
                )}
              </FieldView>
              <FieldView name='Created At:' md={2} vmd={6}>
                {/* TODO: Fix this the next time the file is edited. */}
                {/* eslint-disable-next-line react/prop-types */}
                {event.createdAt
                  ? // TODO: Fix this the next time the file is edited.
                    // eslint-disable-next-line react/prop-types
                    moment(event.createdAt) // TODO: Fix this the next time the file is edited.
                      // eslint-disable-next-line react/prop-types
                      .tz(event.startTz)
                      .format('MM/DD/YYYY')
                  : notAvailableLabel}
              </FieldView>
              {centerFrom.lat ? (
                <div className='location'>
                  <FieldView name='Location From' md={2} vmd={6}>
                    <div className='map-description'>
                      <i
                        className='fas fa-map-marker-alt'
                        style={{ marginRight: '10px' }}
                      />
                      {addressFrom}
                    </div>
                    <div className='map-frame'>
                      {
                        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                        // @ts-ignore
                        <Map
                          google={google}
                          initialCenter={centerFrom}
                          style={{
                            width: '70%',
                            height: '400px',
                            border: 'none',
                          }}
                          Zoom={11}
                        >
                          <Marker position={centerFrom} />
                        </Map>
                      }
                    </div>
                  </FieldView>
                </div>
              ) : (
                <FieldView name='Location From' md={2} vmd={4}>
                  {addressFrom}
                </FieldView>
              )}
              {centerTo.lat ? (
                <div className='location'>
                  <FieldView name='Location To' md={2} vmd={6}>
                    <div className='map-description'>
                      <i
                        className='fas fa-map-marker-alt'
                        style={{ marginRight: '10px' }}
                      />
                      {addressTo}
                    </div>
                    <div className='map-frame'>
                      {
                        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                        // @ts-ignore
                        <Map
                          google={google}
                          initialCenter={centerTo}
                          style={{
                            width: '70%',
                            height: '400px',
                            border: 'none',
                          }}
                          Zoom={11}
                        >
                          <Marker position={centerTo} />
                        </Map>
                      }
                    </div>
                  </FieldView>
                </div>
              ) : (
                <FieldView name='Location To:' md={2} vmd={4}>
                  {addressTo}
                </FieldView>
              )}
              <FieldView name='Description:' md={2} vmd={4}>
                {/* TODO: Fix this the next time the file is edited. */}
                {/* eslint-disable-next-line react/prop-types */}
                {event.eventDescription || notAvailableLabel}
              </FieldView>
              <FieldView name='Duration:' md={2} vmd={4}>
                {/* TODO: Fix this the next time the file is edited. */}
                {/* eslint-disable-next-line react/prop-types */}
                {event.duration || notAvailableLabel}
              </FieldView>
              <FieldView name='Budget Type:' md={2} vmd={4}>
                {/* TODO: Fix this the next time the file is edited. */}
                {/* eslint-disable-next-line react/prop-types */}
                {event.costType || notAvailableLabel}
              </FieldView>
            </div>
            <div
              className={!isMobileResolution() ? 'data-box' : ''}
              style={{ margin: '20px 0', position: 'relative' }}
            >
              <div style={{ fontSize: '18px', textDecoration: 'underline' }}>
                Optional Details:
              </div>
              <CollapsableItem top={isMobileResolution() ? '-31px' : ''}>
                <FieldView name='Est.Budget:' md={2} vmd={4}>
                  {/* TODO: Fix this the next time the file is edited. */}
                  {/* eslint-disable-next-line react/prop-types */}
                  {event.cost && event.costType
                    ? // TODO: Fix this the next time the file is edited.
                      // eslint-disable-next-line react/prop-types
                      event.cost
                    : notAvailableLabel}
                </FieldView>
                <FieldView name='Surprise Event:' md={2} vmd={4}>
                  {/* TODO: Fix this the next time the file is edited. */}
                  {/* eslint-disable-next-line react/prop-types */}
                  {event.isSecret ? 'Yes' : 'No'}
                </FieldView>
                <FieldView name='Dress Code:' md={2} vmd={4}>
                  {/* TODO: Fix this the next time the file is edited. */}
                  {/* eslint-disable-next-line react/prop-types */}
                  {event.dressCode || notAvailableLabel}
                </FieldView>
                <FieldView name='Attendees:' md={2} vmd={4}>
                  <div style={{ fontWeight: '600' }}>
                    {/* TODO: Fix this the next time the file is edited. */}
                    {/* eslint-disable-next-line react/prop-types */}
                    {attendees.length}/{allMembers.length}party members:
                  </div>
                  {/* TODO: Fix this the next time the file is edited. */}
                  {/* eslint-disable-next-line react/prop-types */}
                  {attendees.map(member => (
                    // TODO: Fix this the next time the file is edited.
                    // eslint-disable-next-line react/jsx-key
                    <div key={member.memberName} className='row memb-descr'>
                      {member.memberName}
                    </div>
                  ))}
                </FieldView>
              </CollapsableItem>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyBAAIr9HbcVCnLHgCw8WXXdLV47unpA_I8',
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
})(GroundTransportEventView);
